export const DESKTOP_MIN_WIDTH = 992;
